module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-31.c008566d.png";